<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex x16>

          <organization-chart :datasource="chartData" parentNodeSymbol=""></organization-chart>        

      </v-flex>
    </v-layout>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import OrganizationChart from 'vue-organization-chart';
import 'vue-organization-chart/dist/orgchart.css';

export default {
  components: {
    OrganizationChart
  },
  data () {
    return {
      search: '',
      chartData: {
        name: 'JavaScript',
        children: [
          { name: 'Angular' },
          {
            name: 'React',
            children: [{ name: 'Preact' }]
          },
          {
            name: 'Vue',
            children: [{ name: 'Moon' }]
          }
        ]
      },
      showModalCreate: false,
      showModalDelete: false,
      selectItemActive: null,
      pagination: {
        rowsPerPage: 25
      },
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'client',
        },
        { text: 'Description', value: 'description' },
        { text: 'Type', value: 'type' },
        { text: 'Managers', value: 'managers' },
        { text: 'Parent', value: 'parent' },
        { text: 'Actions', value: 'actiions', sortable: false }
      ],
      deviceGroups: [],
    };
  },
  computed: {
    ...mapGetters(['loading', 'clients', 'client'])
  },
  watch: {
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.$store.commit('setLoading', true);
      let url = '/client/devicegroups_organization';
      window.axios.get(url).then((response) => {
        this.chartData = response.data;
        this.$store.commit('setLoading', false);
      });
    },
    openModalCreate () {
      this.showModalCreate = true;
    },
    closeModalCreate () {
      this.showModalCreate = false;
      this.selectItemActive = null;
    },
  }
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
  .color{
    display: block;
    width: 50px;
    height: 20px;
  }
  .orgchart .title {
    background-color: #006699 !important;
    font-size: 14px;
  }
  .orgchart .lines .downLine {
    background-color: #006699 !important;
  }
  .orgchart .node .content{
    border: 1px solid #006699;
  }
  .orgchart .lines .topLine{
    border-top: 1px solid #006699;
  }
  .orgchart .lines .leftLine{
    border-left: 1px solid #006699;
  }
  .orgchart .lines .rightLine{
    border-right: 1px solid #006699;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/devicegroups/Organization.vue